import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const JOB_FUNCTION_RESTORE_RESOURCE = "job-function" as const;
export const JOB_FUNCTION_RESTORE_API_PATH = `/v1/${JOB_FUNCTION_RESTORE_RESOURCE}/{uuid}/restore` as const;

export type JobFunctionRestoreResponse =
  paths[typeof JOB_FUNCTION_RESTORE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useJobFunctionRestoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<JobFunctionRestoreResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<JobFunctionRestoreResponse>(
        `/v1/${JOB_FUNCTION_RESTORE_RESOURCE}/${uuid}/restore`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [JOB_FUNCTION_RESTORE_RESOURCE],
      });
    },
  });
};
